import React from 'react'
import Div from '@jarvis.oddle/core/components/Div'
import { marginSizes, paddingSizes } from '@jarvis.oddle/core/theme/default'
import styled from 'styled-components'
import { Column, Grid, Row } from '@jarvis.oddle/core/components/Grid'
import Newsletter from './Newsletter'
import SocialMedia from './SocialMedia'
import CustomText from './CustomText'

const CustomisationContainer = styled(Div).attrs(() => ({
  paddingBottom: paddingSizes.large
}))`
  border-bottom: 1px solid ${(props) => props.theme.colorLinesAndBorders};
`

const StyledBlock = styled(Div).attrs(() => ({
  marginTop: marginSizes.large
}))``

const CustomisationContent = ({
  blocksData,
  previewMode,
  newsletterSignupAction
}: {
  blocksData: {
    id: string
    type: string
    settings: {
      bodyText: string
      headingsText: string
      requestSubscriberName: boolean
      successMessageText: string
      facebookUrl: string
      instagramUrl: string
      twitterUrl: string
      youtubeUrl: string
    }
  }[]
  previewMode: boolean
  newsletterSignupAction: ({
    email,
    firstName,
    lastName
  }: {
    email: string
    firstName: string
    lastName: string
  }) => Promise<{
    meta: {
      requestStatus: string
    }
  }>
}): JSX.Element => {
  const numberOfBlock = blocksData.length
  if (numberOfBlock === 0) return null

  return (
    <CustomisationContainer>
      <Grid>
        <Row>
          {blocksData.map((blockData) => {
            let blockElement = null
            switch (blockData.type) {
              case 'custom-text':
                blockElement = <CustomText settings={blockData.settings} />
                break
              case 'newsletter':
                blockElement = (
                  <Newsletter
                    settings={blockData.settings}
                    previewMode={previewMode}
                    newsletterSignupAction={newsletterSignupAction}
                  />
                )
                break
              case 'social-media':
                blockElement = <SocialMedia settings={blockData.settings} />
                break
            }
            return (
              <Column key={blockData.id} sm={12} lg={12 / numberOfBlock}>
                <StyledBlock>{blockElement}</StyledBlock>
              </Column>
            )
          })}
        </Row>
      </Grid>
    </CustomisationContainer>
  )
}

export default CustomisationContent
